import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import { Logo } from '../../icons/Logo';

import './LoginFailedModal.scss';

class LoginFailedModal extends React.Component {
    getWording() {
        const { i18n, loginState } = this.props;

        if (loginState === 1) {
            return convertHtmlToReactDomWithParams(i18n.LOGIN_FAILED_USER_UNREGISTERED);
        } else if (loginState === 2) {
            return convertHtmlToReactDomWithParams(i18n.LOGIN_FAILED_EMAIL_ALREADY_USED);
        } else if (loginState === 3) {
            return convertHtmlToReactDomWithParams(i18n.LOGIN_FAILED_EMAIL_IS_NULL);
        } else {
            return convertHtmlToReactDomWithParams(i18n.LOGIN_FAILED);
        }
    }

    render() {
        return (
            <div className="login-failed">
                <Logo />
                <p className="content">{this.getWording()}</p>
            </div>
        );
    }
}

LoginFailedModal.propTypes = {
    loginState: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.login
    };
};

export default connect(mapStateToProps)(LoginFailedModal);



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginFailedModal.js